import React from 'react';
import { StepProps } from '../MultiStepModal';
import {
  DocumentCheckIcon,
  ExclamationTriangleIcon,
  CalendarDaysIcon,
  BuildingOfficeIcon,
} from '@heroicons/react/24/outline';

export default function CertificateReviewStep({ data }: StepProps) {
  const issueDateLabel = data.issueDate ? new Date(data.issueDate).toLocaleDateString('en-GB') : '—';
  const expiryDateLabel = data.expiryDate ? new Date(data.expiryDate).toLocaleDateString('en-GB') : '—';

  const typeLabel = String(data.type || '').replace(/_/g, ' ').toLowerCase();
  const prettyType = typeLabel ? typeLabel.charAt(0).toUpperCase() + typeLabel.slice(1) : '—';

  const notes = [String(data.notes || '').trim(), String(data.remedialActions || '').trim()]
    .filter(Boolean)
    .join('\n\n');

  return (
    <div className="step-form">
      <div className="step-header">
        <h3 className="step-form-title">Review & Generate</h3>
        <p className="step-form-subtitle">Confirm the details before generating the PDF certificate.</p>
      </div>

      <div className="step-form-content">
        <div className="review-section">
          <h4 className="review-section-title">
            <DocumentCheckIcon className="w-4 h-4 inline mr-2" />
            Certificate
          </h4>
          <div className="review-grid">
            <div className="review-item">
              <span className="review-label">Type:</span>
              <span className="review-value">{prettyType}</span>
            </div>
            <div className="review-item">
              <span className="review-label">Certificate number:</span>
              <span className="review-value">{data.certificateNumber?.trim() || 'Auto-generate'}</span>
            </div>
            <div className="review-item">
              <span className="review-label">
                <CalendarDaysIcon className="w-4 h-4 inline mr-1" />
                Issue date:
              </span>
              <span className="review-value">{issueDateLabel}</span>
            </div>
            <div className="review-item">
              <span className="review-label">
                <CalendarDaysIcon className="w-4 h-4 inline mr-1" />
                Expiry date:
              </span>
              <span className="review-value">{expiryDateLabel}</span>
            </div>
          </div>
        </div>

        <div className="review-section">
          <h4 className="review-section-title">
            <BuildingOfficeIcon className="w-4 h-4 inline mr-2" />
            Customer
          </h4>
          <div className="review-grid">
            <div className="review-item">
              <span className="review-label">Name:</span>
              <span className="review-value">{data.customerName || '—'}</span>
            </div>
            {data.customerPhone ? (
              <div className="review-item">
                <span className="review-label">Phone:</span>
                <span className="review-value">{data.customerPhone}</span>
              </div>
            ) : null}
            {data.customerEmail ? (
              <div className="review-item">
                <span className="review-label">Email:</span>
                <span className="review-value">{data.customerEmail}</span>
              </div>
            ) : null}
          </div>
          <div className="review-item full-width">
            <span className="review-label">Address:</span>
            <p className="review-description">{data.customerAddress || '—'}</p>
          </div>
        </div>

        {notes ? (
          <div className="review-section">
            <h4 className="review-section-title">Notes</h4>
            <div className="review-item full-width">
              <p className="review-description whitespace-pre-wrap">{notes}</p>
            </div>
          </div>
        ) : null}

        <div className="review-notice">
          <ExclamationTriangleIcon className="w-5 h-5 text-orange-500" />
          <div>
            <p className="notice-title">Generate PDF</p>
            <p className="notice-text">
              We&apos;ll generate a PDF and attach it to this certificate for download and sharing.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
